const forgotPasswordConfig = ($stateProvider) => {

  'ngInject';

  $stateProvider
    .state('forgot-password', {
      url: '/forgot-password',
      template: '<app-forgot-password></app-forgot-password>',
      access: {
        loginRequired: false,
      },
      resolve: {
        // used to set the page title
        $title: () => 'Forgot Password',
      },
    });
};

export default forgotPasswordConfig;



// WEBPACK FOOTER //
// ./src/modules/forgot-password/forgot-password.config.js